import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    Lane,
} from 'app/Apps/OrderManagement/Lanes/lanes.types'

import requests from 'app/requests/ContractBasis/LaneGroup/Lane/LaneOps.requests'

const useGetLaneOpsInformation = ({
    selectedLaneId,
    enabled = true,
}: {
    selectedLaneId: number,
    enabled?: boolean,
}) => {
    const {
        data: lane,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<Lane>({
        key: RequestKeys.getSelectedLaneForNewCustomerTransport,
        params: {
            id: selectedLaneId,
        },
        requestFunc: RequestFn.getEntity(requests.laneOpsInformation),
        enabled: Boolean(selectedLaneId) && enabled,
    })

    return {
        lane,
        isDataReady,
        isFetching,
        isError,
        error,
    }
}

export default useGetLaneOpsInformation
